module.exports = __webpack_public_path__ + "img/DanaBerggren.3bab38ca.jpg";